import React, { useState, useEffect, useContext, useMemo } from 'react';
import styles from './UnitsResident.module.css';

import Panel from '../../../Components/Panel/Panel';
import RemoveIdsNotFound from '../../../Components/RemoveIdsNotFound/RemoveIdsNotFound';
import ExecuteAxios from '../../../Components/ExecuteAxios/ExecuteAxios';
import ResetVariables from '../../../Components/ResetVariables/ResetVariables';
import ApplyAttributes from '../../../Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from '../../../Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import { AuthContext } from '../../../Contexts/auth';
import PanelListDefault from '../../../Components/PanelListDefault/PanelListDefault';
import OptionsDataByAttributePath from '../../../Components/Options/optionsData/OptionsDataByAttributePath';
import LoadingIndicator from '../../../Components/LoadingIndicator/LoadingIndicator';

function UnitsResident({ residentId }) {
    const { clientSelected } = useContext(AuthContext);
    const [id, setId] = useState(null)
    const [consumerUnitId, setConsumerUnitId] = useState(null);
    const [isOwner, setIsOwner] = useState('N');
    const [isResident, setIsResident] = useState('N');
    const [isActive, setIsActive] = useState('S')

    const [descriptionLookup, setterDescriptionLookup] = useState('')
    const [unitsResidentRecords, setUnitsResidentRecords] = useState(null)
    const [unitsResidentRecordDetail, setUnitsResidentRecordDetail] = useState(null)
    const [selectedsUnitsResident, setSelectsUnitsResident] = useState([])
    const [unitsResidenceLookup, setUnitsResidenceLookup] = useState([])
    const [inserting, setInserting] = useState(false)
    const [updating, setUpdating] = useState(false)
    const [loadingPanel, setLoadingPanel] = useState(false)
    const unitsResidenceOptions = OptionsDataByAttributePath(unitsResidenceLookup, ['description'], null, true)

    const fetchEmployees = async () => {
        const parameters = {
            clientId: clientSelected ?? 0
        };
        setUnitsResidenceLookup(await ExecuteAxios.api('get', '/consumer-unit/get-consumer-unit-lookup/', { params: parameters }));
    };

    useEffect(() => {
        const fetchData = (async () => {
            await getUnitsResidentDetail(0)
        })

        fetchData()
    }, []);

    useEffect(() => {
        fetchEmployees();
    }, []);

    useEffect(() => {
        const fetchData = (async () => {
            setInserting(false)
            setUpdating(false)
            await getUnitsResidentGrid()
        })

        fetchData()
    }, [residentId]);

    useEffect(() => {
        setDetailRecord(selectedsUnitsResident)
    }, [selectedsUnitsResident]);

    const attributeList = useMemo(() => [
        { name: "id", value: id, setter: setId },
        { name: "consumerUnitId", value: consumerUnitId, setter: setConsumerUnitId, comboboxOptions: unitsResidenceOptions, description: descriptionLookup, setterDescription: setterDescriptionLookup },
        {
            name: "isOwner", value: isOwner, setter: setIsOwner, defaultValue: 'N',
            checks: [
                { field: 'isOwner', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        {
            name: "isResident", value: isResident, setter: setIsResident, defaultValue: 'N',
            checks: [
                { field: 'isResident', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        {
            name: "isActive", value: isActive, setter: setIsActive, defaultValue: 'S',
            checks: [
                { field: 'isActive', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
    ], [id, setId, consumerUnitId, setConsumerUnitId, unitsResidenceOptions, descriptionLookup, setterDescriptionLookup, isActive, setIsActive]);


    async function setDetailRecord(selectedsUnitsResident) {
        if (selectedsUnitsResident && selectedsUnitsResident.length === 1) {
            setInserting(false)
            setUpdating(false)
            await getUnitsResidentDetail(selectedsUnitsResident[0])
        } else {
            setUpdating(false)
            ResetVariables.resetVariables(attributeList)
        }
    }

    async function getUnitsResidentGrid() {
        const parameters = {
            clientId: clientSelected ?? 0,
            residentId: residentId ?? 0
        }
        const unitsResidentRecordsResponse = await ExecuteAxios.api('get', `/consumer-unit-resident-client/get-consumer-unit-resident-client-active-grid/`, { params: parameters });
        setUnitsResidentRecords(unitsResidentRecordsResponse);
        RemoveIdsNotFound.remove(unitsResidentRecordsResponse, setSelectsUnitsResident, selectedsUnitsResident)
    }

    async function getUnitsResidentDetail(selectedResident) {
        const parameters = {
            id: selectedResident
        }
        const unitsResidentRecordsDetail = await ExecuteAxios.api('get', `/consumer-unit-resident-client/get-consumer-unit-resident-client-by-id-detail/`, { params: parameters });
        setUnitsResidentRecordDetail(unitsResidentRecordsDetail);
        if (unitsResidentRecordsDetail) {
            ApplyAttributes.applyAttributes(unitsResidentRecordsDetail, attributeList, inserting)
        }
    }

    async function putUnitsResident() {
        try {
            setLoadingPanel(true)
            const parameters = {
                id: selectedsUnitsResident[0],
                residentId: residentId,
                isOwner: isOwner,
                isResident: isResident,
                clientId: clientSelected ?? 0,
                consumerUnitId: consumerUnitId,
                isActive: isActive
            }
            return await ExecuteAxios.api('put', `/consumer-unit-resident-client/`, parameters);
        } finally {
            setLoadingPanel(false)
        }
    }

    async function postUnitsResident() {
        try {
            setLoadingPanel(true)
            const parameters = {
                residentId: residentId,
                clientId: clientSelected ?? 0,
                isOwner: isOwner,
                isResident: isResident,
                consumerUnitId: consumerUnitId,
                isActive: isActive
            }
            return await ExecuteAxios.api('post', `/consumer-unit-resident-client/`, parameters);
        } finally {
            setLoadingPanel(false)
        }
    }

    const mainPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
    };

    return (
        <Panel
            style={{ ...mainPanelStyle, borderTop: '1px solid #ccc', height: '50%' }}
            titlePage={'Unidades consumidoras'}
            setUpdating={setUpdating}
            setInserting={setInserting}
            inserting={inserting}
            updating={updating}
            enableEdit={true}
            canEdit={selectedsUnitsResident && selectedsUnitsResident.length === 1}
            putFunction={putUnitsResident}
            enableNewRecord={true}
            canNewRecord={residentId}
            postFunction={postUnitsResident}
            canViewCRUD={true}
            recordsSelected={[]}
            viewOnlyOneRecordCRUD={false}
            resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
            dataListedAttributes={unitsResidentRecords}
            attributeList={attributeList}
            onUpdateIdSelected={setSelectsUnitsResident}
            reloadFilter={async () => {
                await getUnitsResidentGrid()
            }}
            cancelFunction={
                async () => {
                    await setDetailRecord(selectedsUnitsResident)
                }
            }
        >
            <div style={{ height: 'calc(100% - 56px)' }}>
                {inserting || updating ?
                    <LoadingIndicator loaded={unitsResidentRecordDetail && !loadingPanel}>
                        <AutomaticallyListedAttributes
                            list={unitsResidentRecordDetail}
                            attributeList={attributeList}
                            readOnlyAttributes={!inserting && !updating}
                        />
                    </LoadingIndicator>
                    :
                    <LoadingIndicator loaded={unitsResidentRecords && !loadingPanel}>
                        <PanelListDefault
                            onUpdateIdSelected={setSelectsUnitsResident}
                            idsSelected={selectedsUnitsResident}
                            data={unitsResidentRecords}
                            attributeList={attributeList}
                            selectFirstRecord={true}
                            inserting={inserting}
                            updating={updating}
                        />
                    </LoadingIndicator>

                }
            </div>
        </Panel>
    );
}

export default UnitsResident;
